import _ from 'underscore';
import ko from 'knockout';

export default function extend(schema, viewModel, isTraditionalChinese, keys) {
  viewModel.isTraditionalChinese = ko.observable(isTraditionalChinese);

  ko.computed(() => {
    _.each(keys, (key) => {
      let maxLength = viewModel.isTraditionalChinese() ? schema.properties[key].traditionalChineseMaxLength : schema.properties[key].maxLength;

      viewModel[key].maxLength(maxLength);
    });
  });
}
